import { useEffect } from 'react';
import { useOpts } from '../../context';
function useSkipDepositConfirmation(goToNext) {
    var _a = useOpts(), skipDepositConfirmation = _a.linkTokenPayload.skipDepositConfirmation, setAmountSelection = _a.setAmountSelection;
    useEffect(function () {
        if (skipDepositConfirmation) {
            // Default amount selection is remainder. This is how it worked in Jarvis flow.
            // We need to keep it this way for Cash.
            setAmountSelection({
                action: 'partial_switch',
                allocation: { type: 'remainder' },
            });
            // goToNext function may just be a routing function but it also may set amount
            // selection (e.g. this is the case for when the amount is in the token)
            goToNext();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
export default useSkipDepositConfirmation;
